"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BookmarksList;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Bookmark = _interopRequireDefault(require("@material-ui/icons/Bookmark"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _contexts = require("../../contexts");
var _services = require("../../services");
var _styles = _interopRequireDefault(require("./styles"));
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */ // Contexts
// Services
// Styles
function Bookmark(_ref) {
  var {
    bookmark,
    jumpToPage,
    removeBookmark
  } = _ref;
  var classes = (0, _styles.default)();
  var [anchorEl, setAnchorEl] = _react.default.useState(null);
  var {
    isDesktopView,
    setOpenDrawer
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    sessionToken,
    rendition
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    repaintHighlight
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  var handleClose = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };
  var handleItemClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      yield jumpToPage(bookmark.cfi);
      if (!isDesktopView) setOpenDrawer(false);
      repaintHighlight(rendition);
    });
    return function handleItemClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var service = (0, _services.TrackingsService)(appToken, sessionToken);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    key: bookmark.id,
    onClick: handleItemClick,
    button: true,
    className: classes.listItem
  }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    onClick: () => {
      service.trackChapterSelected({
        selectedChapter: bookmark.chapterName
      });
    },
    className: classes.listItemText
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.chapterName
  }, bookmark.chapterName), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.page
  }, "P\xE1gina ".concat(rendition.book.locations.locationFromCfi(bookmark.cfi))))), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "settings",
    "aria-haspopup": "true",
    "aria-controls": "simple-menu",
    onClick: handleClick,
    className: classes.iconMenu
  }, /*#__PURE__*/_react.default.createElement(_MoreVert.default, {
    className: classes.icon
  })), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "simple-menu-".concat(bookmark.id),
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      style: {
        marginTop: 47
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: event => {
      handleClose(event);
      removeBookmark(bookmark.id);
    }
  }, "Excluir marca\xE7\xE3o"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.summaryContainer
  }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    key: bookmark.id,
    onClick: handleItemClick,
    button: true,
    className: classes.summaryInfo
  }, /*#__PURE__*/_react.default.createElement(_Bookmark.default, {
    className: classes.markIcon
  }), /*#__PURE__*/_react.default.createElement(_ListItemText.default, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.summary
  }, bookmark.summary)))), /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: classes.divider
  }));
}
function BookmarksList() {
  var classes = (0, _styles.default)();
  var {
    jumpToPage
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    bookmarks,
    removeBookmark
  } = (0, _react.useContext)(_contexts.BookmarksContext);
  if (bookmarks.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      classes: {
        root: classes.placeholder
      }
    }, "Voc\xEA ainda n\xE3o marcou nenhuma p\xE1gina.");
  }
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    component: "nav",
    className: classes.root
  }, bookmarks.map(bookmark => /*#__PURE__*/_react.default.createElement(Bookmark, {
    bookmark: bookmark,
    jumpToPage: jumpToPage,
    removeBookmark: removeBookmark,
    key: bookmark.cfi
  })));
}
Bookmark.propTypes = {
  bookmark: _propTypes.default.shape({
    cfi: _propTypes.default.string.isRequired,
    chapterName: _propTypes.default.string,
    summary: _propTypes.default.string,
    id: _propTypes.default.number.isRequired
  }).isRequired,
  jumpToPage: _propTypes.default.func.isRequired,
  removeBookmark: _propTypes.default.func.isRequired
};